import { MinusCircle, Pencil, PlusCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useAuth } from "../../Store/auth-context";
import { Product } from "../../Store/interfaces";
import { useScheinContext } from "../../Store/schein-context";
import { useUIContext } from "../../Store/ui-context";
import CustomButton from "../Ui/CustomButton";
import TextInput from "../Ui/TextInput";

interface ProductListProps {
  onProductSelect: (productId: number) => void;
  groupProducts: Product[];
}

type InputValuesType = Record<number, string>;

const ProductList: React.FC<ProductListProps> = ({
  onProductSelect,
  groupProducts,
}) => {
  const { selectedProducts, setSelectedProducts, setProducts, products } =
    useScheinContext();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [uiUpdateTrigger, setUiUpdateTrigger] = useState(false);
  const [inputValues, setInputValues] = useState<InputValuesType>({});

  const [inputPrices, setInputPrices] = useState<InputValuesType>({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, forceUpdate] = useState(false); // State zur Erneuerung des Renderings
  const provisionTypMapping: { [key: string]: number } = {
    Technik: 1,
    Schulung: 2,
    Vertrieb: 3,
    Sonstiges: 5,
    keine: 6,
    "nicht ausgewählt": 0,
  };

  const { bearbeiter } = useAuth();
  const provisionsnehmerOptions = [
    { name: bearbeiter }, // Beispielwert
    { name: "Nicht ausgewählt" },
  ];

  const setAnzahl = (id: number, anzahl: string) => {
    const updatedSelectedProducts = selectedProducts.map((product) => {
      if (product.id === id) {
        // Found the product, create a new object with the updated quantity

        const fAnzahl = parseFloat(anzahl);
        const newQuantity = fAnzahl > 0 ? fAnzahl : 0;

        // console.log("new quantity" + newQuantity);

        return { ...product, menge: newQuantity };
      }

      // Not the product we're looking for, return it as is
      return product;
    });

    setSelectedProducts(updatedSelectedProducts);

    const updatedProducts = products.map((product) => {
      if (product.id === id) {
        // Found the product, create a new object with the updated quantity

        const fAnzahl = parseFloat(anzahl);
        const newQuantity = fAnzahl > 0 ? fAnzahl : 0;

        return { ...product, menge: newQuantity };
      }
      // Not the product we're looking for, return it as is
      return product;
    });

    setProducts([...updatedProducts]);
  };

  // const setAnzahl = (id: number, anzahl: string) => {
  //   const updatedSelectedProducts = selectedProducts.map((product) => {
  //     if (product.id === id) {
  //       const fAnzahl = parseFloat(anzahl);

  //       return { ...product, menge: isNaN(fAnzahl) ? 0 : fAnzahl };
  //     }
  //     return product;
  //   });

  //   setSelectedProducts(updatedSelectedProducts);

  //   const updatedProducts = products.map((product) => {
  //     if (product.id === id) {
  //       const fAnzahl = parseFloat(anzahl);

  //       return { ...product, menge: isNaN(fAnzahl) ? 0 : fAnzahl };
  //     }
  //     return product;
  //   });

  //   setProducts([...updatedProducts]);
  // };

  useEffect(() => {
    // Initialize inputValues with the quantities of the products
    const initialInputValues: InputValuesType = {};
    const initialInputPrices: InputValuesType = {};
    groupProducts.forEach((product) => {
      initialInputValues[product.id] = product.menge.toString();
      initialInputPrices[product.id] = String(product.vk);
    });
    setInputValues(initialInputValues);
    setInputPrices(initialInputPrices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleAnzahlChange = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   id: number
  // ) => {
  //   e.preventDefault();
  //   const value = e.target.value;

  //   // console.log("handleanzahlchange " + value);

  //   if (/^\d*\.?\d*$/.test(value) && value !== "." && !value.endsWith(".")) {
  //     // console.log("Valid numeric input: " + value + " id:" + id);
  //     setInputValues((prev) => ({ ...prev, [id]: value }));
  //     setAnzahl(id, value); // Wenn ja, rufe setAnzahl sofort auf
  //   } else {
  //     // console.log("Invalid numeric input: " + value + " id:" + id);
  //     // Optional: Sie könnten auch entscheiden, hier einen Fallback-Wert zu setzen
  //     setInputValues((prev) => ({ ...prev, [id]: value }));
  //   }
  // };

  const handleAnzahlChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    e.preventDefault();
    let value = e.target.value;

    // Komma durch Punkt ersetzen
    value = value.replace(",", ".");

    // Aktualisiere das Input-Feld sofort
    setInputValues((prev) => ({ ...prev, [id]: value }));

    // Wenn leer, nicht parsen oder updaten – einfach zurück
    if (value.trim() === "") return;

    // Validierung auf positive Zahl
    const num = Number(value);
    if (!isNaN(num) && num >= 0) {
      setAnzahl(id, value);
    }
  };

  const handlePriceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    e.preventDefault();
    const value = e.target.value;

    if (/^\d*\.?\d*$/.test(value) && value !== "." && !value.endsWith(".")) {
      // console.log("handlePreisChange input brr: " + value);
      setInputPrices((prev) => ({ ...prev, [id]: value }));
      updatePrice(id, value); // Wenn ja, rufe setAnzahl sofort auf
    } else {
      // console.log("handlePreisChange input: " + value);
      // Optional: Sie könnten auch entscheiden, hier einen Fallback-Wert zu setzen
      setInputPrices((prev) => ({ ...prev, [id]: value }));
    }
  };

  // const anzahlPlus = (id: number) => {
  //   const updatedProducts = products.map((product) => {
  //     if (product.id === id) {
  //       // Found the product, create a new object with the updated quantity
  //       console.log("product.menge", product.menge);

  //       // const newQuantity = product.menge ? product.menge + 1 : 1;
  //       // const newQuantity = (product.menge ?? 0) + 1;
  //       const newQuantity =
  //         product.menge === 0 ? product.menge : product.menge + 1;

  //       setInputValues((prev) => ({ ...prev, [id]: newQuantity.toString() }));
  //       console.log("new q2: " + newQuantity);
  //       return { ...product, menge: newQuantity };
  //     }
  //     // Not the product we're looking for, return it as is
  //     return product;
  //   });
  //   setProducts([...updatedProducts]);

  //   const updatedSelectedProducts = selectedProducts.map((product) => {
  //     if (product.id === id) {
  //       // Found the product, create a new object with the updated quantity
  //       console.log("product.menge", product.menge);

  //       // const newQuantity = product.menge ? product.menge + 1 : 1;
  //       const newQuantity = (product.menge ?? 0) + 1;

  //       console.log("new q1: " + newQuantity);
  //       return { ...product, menge: newQuantity };
  //     }
  //     // Not the product we're looking for, return it as is
  //     return product;
  //   });

  //   setSelectedProducts(updatedSelectedProducts);
  // };

  // const anzahlMinus = (id: number) => {
  //   // Prüfung ob Produkt bereits selected war
  //   const updatedSelectedProducts = selectedProducts.map((product) => {
  //     if (product.id === id) {
  //       // Found the product, create a new object with the updated quantity
  //       const newQuantity =
  //         product.menge && product.menge > 0 ? product.menge - 1 : 0;

  //       console.log("new q3", newQuantity);

  //       return { ...product, menge: newQuantity };
  //     }
  //     // Not the product we're looking for, return it as is
  //     return product;
  //   });

  //   setSelectedProducts(updatedSelectedProducts);

  //   const updatedProducts = products.map((product) => {
  //     if (product.id === id) {
  //       // Found the product, create a new object with the updated quantity

  //       const newQuantity =
  //         product.menge && product.menge > 1 ? product.menge - 1 : 0;

  //       setInputValues((prev) => ({ ...prev, [id]: newQuantity.toString() }));

  //       return { ...product, menge: newQuantity };
  //     }
  //     // Not the product we're looking for, return it as is
  //     return product;
  //   });

  //   setProducts([...updatedProducts]);
  // };

  const anzahlPlus = (id: number) => {
    const updated = selectedProducts.map((product) => {
      if (product.id === id) {
        const newQuantity = (product.menge ?? 0) + 1;
        setInputValues((prev) => ({ ...prev, [id]: newQuantity.toString() }));
        return { ...product, menge: newQuantity };
      }
      return product;
    });

    setSelectedProducts(updated);
  };

  const anzahlMinus = (id: number) => {
    const updated = selectedProducts.map((product) => {
      if (product.id === id) {
        const newQuantity = Math.max((product.menge ?? 0) - 1, 0);
        setInputValues((prev) => ({ ...prev, [id]: newQuantity.toString() }));
        return { ...product, menge: newQuantity };
      }
      return product;
    });

    setSelectedProducts(updated);
  };

  const setProvNehmer = (text: string, id: number) => {
    const updatedSelectedProducts = selectedProducts.map((product) => {
      if (product.id === id) {
        return { ...product, provisionsnehmer: text };
      }
      // Not the product we're looking for, return it as is
      return product;
    });

    setSelectedProducts(updatedSelectedProducts);

    const updatedProducts = products.map((product) => {
      if (product.id === id) {
        return { ...product, provisionsnehmer: text };
      }
      // Not the product we're looking for, return it as is
      return product;
    });

    setProducts([...updatedProducts]);
  };

  const setProvTyp = (text: string, id: number) => {
    const typID = provisionTypMapping[text] || 0;
    const updatedSelectedProducts = selectedProducts.map((product) => {
      if (product.id === id) {
        return { ...product, provisionstyp: text, provisionstypid: typID };
      }
      // Not the product we're looking for, return it as is
      return product;
    });

    setSelectedProducts(updatedSelectedProducts);

    const updatedProducts = products.map((product) => {
      if (product.id === id) {
        return { ...product, provisionstyp: text, provisionstypid: typID };
      }
      // Not the product we're looking for, return it as is
      return product;
    });

    setProducts([...updatedProducts]);
  };

  const updateComment = (text: string, id?: number) => {
    let updated = false;

    const updateProductList = (products: Product[]) =>
      products.map((product: Product) => {
        if (product.id === id) {
          updated = true;
          return { ...product, kommentar: text };
        }
        return product;
      });

    const updatedSelectedProducts = updateProductList(selectedProducts);
    const updatedProducts = updateProductList(products);

    setSelectedProducts(updatedSelectedProducts);
    setProducts(updatedProducts);

    // Use callback form to ensure the latest state is read
    setUiUpdateTrigger((prev) => !prev);

    // Optionally handle the case where no product was updated
    if (!updated) {
      // console.log(`No product found with ID ${id}`);
    }
  };

  const updatePrice = (id: number, preis: string) => {
    let updated = false;

    const updateProductList = (products: Product[]) =>
      products.map((product: Product) => {
        if (product.id === id) {
          updated = true;
          // console.log("updating " + product.artikel + " : " + preis + "  ID:" + product.id);
          return { ...product, vk: parseFloat(preis) }; // convert preis to a number
        }
        return product;
      });

    const updatedSelectedProducts = updateProductList(selectedProducts);
    const updatedProducts = updateProductList(products);

    setSelectedProducts(updatedSelectedProducts);
    setProducts(updatedProducts);

    // Use callback form to ensure the latest state is read
    setUiUpdateTrigger((prev) => !prev);

    // Optionally handle the case where no product was updated
    if (!updated) {
      // console.log(`No product found with ID ${id}`);
    }
  };

  // const handleFocus = (id: number) => {
  //   const input = inputRefs.current[id];
  //   if (input) {
  //     input.select();
  //   }
  // };
  const { showDialog } = useUIContext();

  const handleAddSameProduct = (product: Product) => {
    // Neue ID generieren (ggf. über UUID oder inkrementelle Zahl)
    showDialog({
      title: "Kundeninfo",
      message:
        "Wurde im Serviceschein eindeutig vermerkt, dass mehrere Techniker vor Ort waren?",
      confirmButtonText: "Ja",
      cancelButtonText: "Nein",
      onConfirm: () => {
        const newProduct = {
          ...product,
          id: Date.now(), // Temporäre ID für das neue Produkt
          kommentar: "",
          provisionsnehmer: product.provisionsnehmer,
          provisionstyp: "Technik",
          provisionstypid: provisionTypMapping["Technik"],
          menge: product.menge, // Standardwert für die neue Menge
        };

        setSelectedProducts([...selectedProducts, newProduct]);
      },
    });
  };

  return (
    <div className="w-full relative">
      {groupProducts.map((product: Product) => {
        const isSelected = selectedProducts.some(
          (selectedProduct) => selectedProduct.id === product.id
        );

        if (!product.menge) {
          product.menge = 1;
        }

        const toggleEditing = (product: Product) => {
          forceUpdate((prev) => !prev); // Re-render erzwingen
          product.customprovisionsnehmer = !product.customprovisionsnehmer;
        };

        return (
          <React.Fragment key={product.id}>
            <div
              className="p-4 mt-2 mb-2 border border-gray-300 rounded-lg bg-gray-100
                         shadow-md transition-transform duration-200 ease-in-out
                         hover:scale-105 w-full sm:w-full mx-auto"
              onClick={() => {
                if (!isSelected) {
                  onProductSelect(product.id);
                }
              }}
            >
              {/* Produkt-Informationen */}
              <div className="flex flex-col">
                <p className="font-bold text-lg break-words">
                  {product.artikel} ~ {product.vk}€
                </p>
                <p className="text-sm text-gray-700 break-words">
                  {product.beschreibung}
                </p>
              </div>
              {/* Anzahl-Auswahl */}
              {isSelected && (
                <div className="flex items-center justify-center mt-2">
                  <button
                    onClick={(event) => {
                      event.preventDefault();
                      anzahlMinus(product.id);
                    }}
                    className="p-2 rounded-full hover:bg-gray-200 focus:outline-none"
                    aria-label="Decrease Amount"
                  >
                    <MinusCircle color="currentColor" size={24} />
                  </button>
                  <input
                    type="text"
                    value={inputValues[product.id] || 0}
                    onChange={(e) => handleAnzahlChange(e, product.id)}
                    className="w-11 py-1 px-1 text-center rounded border focus:ring-green-500"
                  />
                  <button
                    onClick={(event) => {
                      event.preventDefault();
                      anzahlPlus(product.id);
                    }}
                    className="p-2 rounded-full hover:bg-gray-200 focus:outline-none"
                    aria-label="Increase Amount"
                  >
                    <PlusCircle color="currentColor" size={24} />
                  </button>
                </div>
              )}
              {/* Kommentar-Feld & Textbausteine */}
              {isSelected && (
                <div className="mt-3 flex flex-col lg:flex-row gap-3">
                  {product.artikel !== "Anfahrtspauschale" ? (
                    <></>
                  ) : (
                    <div className="text-center">Preis</div>
                  )}
                  {product.artikel !== "Anfahrtspauschale" ? (
                    <div className="flex flex-col w-full lg:col-span-8 mr-1">
                      <TextInput
                        name="comment"
                        value={product.kommentar}
                        placeholder="Kommentar"
                        onChange={(text: string) => {
                          updateComment(text, product.id);
                        }}
                        className="w-full h-full lg:col-span-8 mr-1"
                      />
                      <p className="text-xs text-gray-500 mt-1 ml-1 justify-start">
                        * Bearbeiter & Datum werden automatisch hinzugefügt
                      </p>
                    </div>
                  ) : (
                    <input
                      type="text"
                      value={inputPrices[product.id] || "0"}
                      placeholder="Preis"
                      onChange={(e) => handlePriceChange(e, product.id)}
                      className="w-[100px] py-1 px-1 text-center rounded border'focus:ring-green-500"
                    />
                  )}
                </div>
              )}
              {/* Provisionstyp & Provisionsnehmer */}
              {isSelected && (
                <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* Provisionstyp */}
                  <Form.Group controlId="provisionstyp" className="w-full">
                    <Form.Label>
                      <p className="font-bold text-left text-sm sm:text-base">
                        Provisionstyp
                      </p>
                    </Form.Label>
                    <Form.Control
                      as="select"
                      value={product.provisionstyp}
                      onChange={(e) => setProvTyp(e.target.value, product.id)}
                      className="rounded p-2 w-full text-sm sm:text-base"
                    >
                      {Object.keys(provisionTypMapping).map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  {/* Provisionsnehmer */}

                  <Form.Group controlId="provisionsnehmer" className="w-full">
                    <Form.Label>
                      <p className="font-bold text-left text-sm sm:text-base">
                        Provisionsnehmer
                      </p>
                    </Form.Label>
                    <div className="flex items-center w-full">
                      <div className="flex-grow">
                        {product.customprovisionsnehmer ? (
                          <Form.Control
                            type="text"
                            className="rounded p-2 w-full text-sm sm:text-base"
                            value={product.provisionsnehmer}
                            onChange={(e) =>
                              setProvNehmer(e.target.value, product.id)
                            }
                            onBlur={() => {
                              if (!product.provisionsnehmer.trim()) {
                                setProvNehmer(bearbeiter, product.id); // setting bearbeiter as default when empty and leave
                                toggleEditing(product); // switch back to dropdown
                              }
                            }}
                            placeholder="Provisionsnehmer eingeben"
                          />
                        ) : (
                          <Form.Control
                            as="select"
                            className="rounded p-2 w-full text-sm sm:text-base"
                            value={product.provisionsnehmer}
                            onChange={(e) =>
                              setProvNehmer(e.target.value, product.id)
                            }
                          >
                            {provisionsnehmerOptions.map((option, index) => (
                              <option key={index} value={option.name}>
                                {option.name}
                              </option>
                            ))}
                          </Form.Control>
                        )}
                      </div>

                      {/* Stift-Button zum Editieren */}
                      <button
                        type="button"
                        onClick={() => toggleEditing(product)}
                        className="ml-2 p-2 bg-gray-200 rounded"
                      >
                        <Pencil size={16} />
                      </button>
                    </div>
                  </Form.Group>
                </div>
              )}
              {/* Auswahl Button */}
              {isSelected && (
                <CustomButton
                  theme="navy"
                  className="w-full h-10 mt-2"
                  onClick={() => handleAddSameProduct(product)}
                >
                  Erneut hinzufügen
                </CustomButton>
              )}
              <div className="mt-3">
                <CustomButton
                  theme={isSelected ? "red" : "navy"}
                  className="w-full h-10"
                  onClick={() => onProductSelect(product.id)}
                >
                  {isSelected ? "Abwählen" : "Auswählen"}
                </CustomButton>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProductList;
